<div class="d-flex flex-column gap-2 acc-application-status-log-list-part">
	<h4>Application Status Logs</h4>
	<div class="d-flex flex-column">
		@for (accApplicationStatusLog of accApplicationStatusLogs(); track
		accApplicationStatusLog.accApplicationStatusLogId) {
		<div class="d-flex align-items-center border border-light-subtle">
			<div class="icon-class d-flex align-items-center justify-content-center">
				<i [class]="accApplicationStatusLog.icon"></i>
			</div>
			<div class="border-start border-light-subtle flex-1 p-2">
				<div>
					{{accApplicationStatusLog.status}} Application on {{accApplicationStatusLog.updatedUTC }}
				</div>
				<div>
					By: {{accApplicationStatusLog.displayName}}
				</div>
				@if(accApplicationStatusLog.notes) {
				<div>
					Notes: {{accApplicationStatusLog.notes}}
				</div>
				}
			</div>
		</div>
		} @empty {
		<div class="text-center p-2">
			<p>No status logs available for this application.</p>
		</div>
		}
	</div>
</div>